import {
	ArrowBack as ArrowBackIcon,
	Download as DownloadIcon,
	Insights as InsightsIcon,
	Lock as LockIcon,
	MoreVert as MoreVertIcon,
	Person as PersonIcon,
} from '@mui/icons-material'

import {
	CircularProgress,
	Menu,
	Tooltip,
} from '@mui/material'

import {
	formatDateLabel,
	formatPhoneNumber,
	formatTimestampLabel,
} from '../../services/scout'
import { renderExportConversation } from '../../services/utils'

import ConversationMessageBody, {
	getMessageIdentifier,
	getMessageKey,
	getMessageReactions,
	isCardMessage,
	shouldShowDateSeparator,
} from './ConversationMessageBody'
import ConversationAvatar from './ConversationAvatar'

const ConversationThread = ({
	selectedConversation,
	selectedAccount,
	getStableConversationTitle,
	optionsAnchorEl,
	optionsOpen,
	onOpenOptions,
	onCloseOptions,
	onBack,
	onExportConversation,
	onShowInsights,
	onShowProfile,
	enterprise,
	initialMessagesLoading,
	threadRef,
	onThreadScroll,
	renderedMessages,
	messagesLoading,
	loadingMediaIds,
	onLoadMediaMessage,
	messages,
	searchValue,
	onOpenEditHistory,
	messageReactionLookup,
}) => {
	return (
		<section className="scout-panel scout-panel--thread">
			<div className="scout-thread-header">
				<button
					type="button"
					className="scout-back-link scout-back-link--mobile-only"
					onClick={onBack}
				>
					<ArrowBackIcon />
					<span>Voltar</span>
				</button>
				<div className="scout-thread-header__identity">
					<ConversationAvatar conversation={selectedConversation} displayName={getStableConversationTitle(selectedConversation)} className="scout-conversation-row__avatar scout-thread-header__avatar" />
					<div>
						<strong>{getStableConversationTitle(selectedConversation)}</strong>
						<span>{selectedConversation?.phone_num ? formatPhoneNumber(selectedConversation.phone_num) : 'Sem número identificado'}</span>
					</div>
				</div>
				<div className="scout-thread-header__actions">
					<Tooltip title="Mais opções">
						<button type="button" className="scout-icon-button" onClick={onOpenOptions}>
							<MoreVertIcon />
						</button>
					</Tooltip>
					<Menu
						anchorEl={optionsAnchorEl}
						open={optionsOpen}
						onClose={onCloseOptions}
						transformOrigin={{ horizontal: 'right', vertical: 'top' }}
						anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
						PaperProps={{ className: 'scout-support-menu' }}
					>
						<div className="scout-support-menu__items">
							<button type="button" className="scout-support-menu__item" onClick={onExportConversation}>
								{renderExportConversation(enterprise) ? <DownloadIcon /> : <LockIcon />}
								<span>Exportar mensagens</span>
							</button>
							<button type="button" className="scout-support-menu__item" onClick={onShowInsights}>
								<InsightsIcon />
								<span>Insights com IA</span>
							</button>
							<button type="button" className="scout-support-menu__item" onClick={onShowProfile}>
								<PersonIcon />
								<span>Perfil do contato</span>
							</button>
						</div>
					</Menu>
				</div>
			</div>

			{initialMessagesLoading
				? <div className="scout-thread-messages scout-thread-messages--loading">
					<CircularProgress />
				</div>
				: <div className="scout-thread-messages" ref={threadRef} onScroll={onThreadScroll}>
					{renderedMessages.length
						? renderedMessages.map((message, index) => {
							const fromMe = Boolean(message.fromMe)
							const isRestricted = message?.restricted === true
							const previousMessage = index > 0 ? renderedMessages[index - 1] : null
							const reactions = getMessageReactions(message, messageReactionLookup)

							return (
								<div key={getMessageKey(message, index)} className={shouldShowDateSeparator(message, previousMessage) ? 'scout-message-group scout-message-group--with-date' : 'scout-message-group'}>
									{shouldShowDateSeparator(message, previousMessage) ? (
										<div className="scout-message-date-separator">{formatDateLabel(Number(message.timestamp) * 1000)}</div>
									) : null}
									<article className={`scout-message ${fromMe ? 'scout-message--from-me' : ''} ${isRestricted ? 'restricted' : ''} ${reactions.length ? 'scout-message--has-reactions' : ''}`.trim()}>
										<div className={`scout-message__bubble scout-conversation-box ${isCardMessage(message) ? 'scout-message__bubble--card' : ''}`.trim()} data-index={index}>
											<strong>{fromMe ? selectedAccount?.name || 'Atendente' : selectedConversation?.type === 'GROUP' ? (message.pushName || 'Participante') : getStableConversationTitle(selectedConversation) || 'Contato'}</strong>
											<ConversationMessageBody
												message={message}
												onLoadMedia={onLoadMediaMessage}
												messages={messages}
												mediaLoading={Boolean(loadingMediaIds[getMessageIdentifier(message, index)])}
												searchValue={searchValue}
												enterprise={enterprise}
												onOpenEditHistory={onOpenEditHistory}
											/>
											<small>{message.iso_time || formatTimestampLabel(message.timestamp)}</small>
											{reactions.length ? (
												<div className={`scout-message__reactions ${fromMe ? 'scout-message__reactions--from-me' : ''}`.trim()} aria-label="Reações da mensagem">
													{reactions.map((reaction) => (
														<span key={reaction.id} className="scout-message__reaction-chip">{reaction.emoji}</span>
													))}
												</div>
											) : null}
										</div>
									</article>
								</div>
							)
						})
						: <div className="scout-panel__empty scout-panel__empty--thread">Nenhuma mensagem encontrada para esta conversa.</div>
					}
					{messagesLoading && renderedMessages.length
						? <div className="scout-thread-loading scout-thread-loading--inline">
							Carregando mensagens antigas...
						</div>
						: null
					}
				</div>
			}
		</section>
	)
}

export default ConversationThread